<div class="iframe-container">
  <div class="iframe-content">
    <iframe 
      [src]="iframeUrl | safe" 
      frameborder="0" 
      width="100%" 
      height="100%"
      allowfullscreen>
    </iframe>
  </div>
</div> 